export default __webpack_public_path__ + "static/media/male-icon.b4109261.svg";